export default "__VITE_PUBLIC_ASSET__5d8f8484__"